// extracted by mini-css-extract-plugin
export default {"iframe":"PartnersGlobe_iframe__eQMjn"};